module.exports = __webpack_public_path__ + "static/media/default.4dcbc777.png";


//////////////////
// WEBPACK FOOTER
// ./src/carAnnualReview/index/default.png
// module id = 1186
// module chunks = 0